import { render, staticRenderFns } from "./confeti.vue?vue&type=template&id=80bb6616"
import script from "./confeti.vue?vue&type=script&lang=js"
export * from "./confeti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports